(function () {
  var DUMP_MS = 150;
  var LOS_MIN = 10;
  var LOS_MAX = 500;
  var ANGLE_MIN = 0;
  var ANGLE_MAX = 90;
  var CHART_LOS = [20, 30, 40, 50, 60, 80, 100, 150, 200, 300, 400, 500];
  var CHART_ANG = [10, 20, 30, 40, 50, 60, 70, 80, 90];

  function num(el) {
    if (!el) return null;
    var v = parseFloat(String(el.value).replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  function clamp(n, min, max) {
    if (n == null || !isFinite(n)) return null;
    return Math.min(max, Math.max(min, n));
  }

  function fmt(n, digits) {
    if (n == null || !isFinite(n)) return '—';
    var p = Math.pow(10, digits);
    return (Math.round(n * p) / p).toFixed(digits);
  }

  function pinYards(los, angleDeg) {
    return los * Math.cos((angleDeg * Math.PI) / 180);
  }

  function heightYards(los, angleDeg) {
    return los * Math.sin((angleDeg * Math.PI) / 180);
  }

  function setFill(el) {
    if (!el || el.type !== 'range') return;
    var min = parseFloat(el.min);
    var max = parseFloat(el.max);
    var val = parseFloat(el.value);
    if (!isFinite(min) || !isFinite(max) || max === min || !isFinite(val)) return;
    el.style.setProperty('--sac-fill', ((val - min) / (max - min)) * 100 + '%');
  }

  function setChip(el, text) {
    if (el) el.textContent = text;
  }

  function closestIndex(values, current) {
    var best = 0;
    var bestAbs = Infinity;
    for (var i = 0; i < values.length; i++) {
      var d = Math.abs(values[i] - current);
      if (d < bestAbs) {
        bestAbs = d;
        best = i;
      }
    }
    return best;
  }

  function closestValue(list, current) {
    return list[closestIndex(list, current)];
  }

  function dumpConsole(state) {
    console.group(
      '[Shot angle] pin ' + fmt(state.pin, 1) + ' yd  ·  LOS ' + state.los + '  ·  ' + state.angle + '°'
    );
    console.log('Inputs', {
      losYards: state.los,
      angleDeg: state.angle,
      slope: state.slope,
    });
    console.groupEnd();
  }

  function buildChart(table) {
    if (!table || table.getAttribute('data-sac-chart-ready')) return;
    table.setAttribute('data-sac-chart-ready', '1');

    var thead = document.createElement('thead');
    var headRow = document.createElement('tr');
    var corner = document.createElement('th');
    corner.scope = 'col';
    corner.textContent = 'LOS (yd)';
    headRow.appendChild(corner);
    for (var a = 0; a < CHART_ANG.length; a++) {
      var th = document.createElement('th');
      th.scope = 'col';
      th.textContent = CHART_ANG[a] + '°';
      headRow.appendChild(th);
    }
    thead.appendChild(headRow);
    table.appendChild(thead);

    var tbody = document.createElement('tbody');
    tbody.setAttribute('data-sac-chart-body', '');
    for (var i = 0; i < CHART_LOS.length; i++) {
      var los = CHART_LOS[i];
      var tr = document.createElement('tr');
      var rowTh = document.createElement('th');
      rowTh.scope = 'row';
      rowTh.textContent = String(los);
      tr.appendChild(rowTh);
      for (var j = 0; j < CHART_ANG.length; j++) {
        var ang = CHART_ANG[j];
        var td = document.createElement('td');
        td.setAttribute('data-sac-cell', '');
        td.setAttribute('data-sac-los', String(los));
        td.setAttribute('data-sac-ang', String(ang));
        td.textContent = fmt(los - pinYards(los, ang), 1);
        tr.appendChild(td);
      }
      tbody.appendChild(tr);
    }
    table.appendChild(tbody);
  }

  function highlightChart(table, los, angle) {
    if (!table) return;
    var nearLos = closestValue(CHART_LOS, los);
    var nearAng = closestValue(CHART_ANG, angle);
    table.querySelectorAll('[data-sac-cell]').forEach(function (td) {
      var on =
        Number(td.getAttribute('data-sac-los')) === nearLos &&
        Number(td.getAttribute('data-sac-ang')) === nearAng;
      td.classList.toggle('is-current', on);
    });
  }

  function slopeValue(root) {
    var on = root.querySelector('[data-sac-slope][aria-pressed="true"]');
    return (on && on.getAttribute('data-sac-slope')) || 'down';
  }

  function init(root) {
    if (root.getAttribute('data-sac-ready')) return;
    root.setAttribute('data-sac-ready', '1');

    var losEl = root.querySelector('[data-sac-los]');
    var losNumEl = root.querySelector('[data-sac-los-num]');
    var angleEl = root.querySelector('[data-sac-angle]');
    var angleNumEl = root.querySelector('[data-sac-angle-num]');
    var chipLos = root.querySelector('[data-sac-chip-los]');
    var chipAngle = root.querySelector('[data-sac-chip-angle]');
    var outPin = root.querySelector('[data-sac-out-pin]');
    var outCut = root.querySelector('[data-sac-out-cut]');
    var outHeight = root.querySelector('[data-sac-out-height]');
    var teach = root.querySelector('[data-sac-teach]');
    var chart = root.querySelector('[data-sac-chart]');
    var dumpTimer = null;
    var lastState = null;

    buildChart(chart);

    var tools = window.TitleXCalcTools;
    if (tools) {
      tools.wireTableExport(chart, { filename: 'shot-angle-cut-chart' });
      tools.addCopyButton(root.querySelector('[data-sac-results]'), 'Copy pin / cut / height', function () {
        if (!lastState) return '';
        return [
          'Line of sight (yd): ' + lastState.los,
          'Angle (deg): ' + lastState.angle,
          'Pin this (yd): ' + fmt(lastState.pin, 1),
          'Cut from LOS (yd): ' + fmt(lastState.cut, 1),
          'Height above/below (yd): ' + fmt(lastState.height, 1),
          'Slope: ' + lastState.slope,
        ].join('\n');
      });
    }

    function scheduleDump(state) {
      clearTimeout(dumpTimer);
      dumpTimer = setTimeout(function () {
        dumpConsole(state);
      }, DUMP_MS);
    }

    function syncLosFromSlider() {
      var T = window.TitleXCalcTools;
      if (T && T.syncNumFromSlider) T.syncNumFromSlider(losEl, losNumEl, Math.round);
      else if (losNumEl && num(losEl) != null) losNumEl.value = String(Math.round(num(losEl)));
    }

    function syncLosFromNum() {
      var T = window.TitleXCalcTools;
      if (T && T.syncSliderFromNum) T.syncSliderFromNum(losNumEl, losEl, LOS_MIN, LOS_MAX, Math.round);
      else {
        var v = num(losNumEl);
        if (v != null && losEl) losEl.value = String(clamp(v, LOS_MIN, LOS_MAX));
      }
    }

    function syncAngleFromSlider() {
      var T = window.TitleXCalcTools;
      if (T && T.syncNumFromSlider) T.syncNumFromSlider(angleEl, angleNumEl, Math.round);
      else if (angleNumEl && num(angleEl) != null) angleNumEl.value = String(Math.round(num(angleEl)));
    }

    function syncAngleFromNum() {
      var T = window.TitleXCalcTools;
      if (T && T.syncSliderFromNum) T.syncSliderFromNum(angleNumEl, angleEl, ANGLE_MIN, ANGLE_MAX, Math.round);
      else {
        var v = num(angleNumEl);
        if (v != null && angleEl) angleEl.value = String(clamp(v, ANGLE_MIN, ANGLE_MAX));
      }
    }

    function readLosForCalc() {
      var T = window.TitleXCalcTools;
      if (losNumEl && document.activeElement === losNumEl && T && T.parseInputNum) {
        var raw = T.parseInputNum(losNumEl);
        if (raw == null) return clamp(num(losEl), LOS_MIN, LOS_MAX);
        if (raw >= LOS_MIN && raw <= LOS_MAX) return Math.round(raw);
        return clamp(num(losEl), LOS_MIN, LOS_MAX);
      }
      return T && T.readPairedInput
        ? T.readPairedInput(losEl, losNumEl, LOS_MIN, LOS_MAX)
        : clamp(num(losEl), LOS_MIN, LOS_MAX);
    }

    function readAngleForCalc() {
      var T = window.TitleXCalcTools;
      if (angleNumEl && document.activeElement === angleNumEl && T && T.parseInputNum) {
        var raw = T.parseInputNum(angleNumEl);
        if (raw == null) return clamp(num(angleEl), ANGLE_MIN, ANGLE_MAX);
        if (raw >= ANGLE_MIN && raw <= ANGLE_MAX) return Math.round(raw);
        return clamp(num(angleEl), ANGLE_MIN, ANGLE_MAX);
      }
      return T && T.readPairedInput
        ? T.readPairedInput(angleEl, angleNumEl, ANGLE_MIN, ANGLE_MAX)
        : clamp(num(angleEl), ANGLE_MIN, ANGLE_MAX);
    }

    function recalc() {
      var los = readLosForCalc();
      var angle = readAngleForCalc();
      var slope = slopeValue(root);

      ;[losEl, angleEl].forEach(setFill);
      setChip(chipLos, los != null ? los + ' yd' : '—');
      setChip(chipAngle, angle != null ? angle + '°' : '—');

      if (teach) {
        teach.textContent =
          'Uphill or downhill — same pin. Aim for horizontal yards, not laser distance.';
      }

      if (los == null || angle == null) {
        if (outPin) outPin.textContent = '—';
        if (outCut) outCut.textContent = '—';
        if (outHeight) outHeight.textContent = '—';
        lastState = null;
        return;
      }

      var pin = pinYards(los, angle);
      var height = heightYards(los, angle);
      var cut = los - pin;

      if (outPin) outPin.textContent = fmt(pin, 1);
      if (outCut) outCut.textContent = fmt(cut, 1);
      if (outHeight) outHeight.textContent = fmt(height, 1);

      highlightChart(chart, los, angle);

      lastState = {
        los: los,
        angle: angle,
        pin: pin,
        cut: cut,
        height: height,
        slope: slope,
      };
      scheduleDump(lastState);
    }

    var sacTools = window.TitleXCalcTools;
    if (sacTools && sacTools.wireCalcInputs) {
      sacTools.wireCalcInputs(root, {
        recalc: recalc,
        pairs: [
          { slider: losEl, num: losNumEl, fromSlider: syncLosFromSlider, normalize: syncLosFromNum },
          { slider: angleEl, num: angleNumEl, fromSlider: syncAngleFromSlider, normalize: syncAngleFromNum },
        ],
      });
    } else {
      root.addEventListener('input', function (e) {
        if (e.target === losNumEl) syncLosFromNum();
        if (e.target === angleNumEl) syncAngleFromNum();
        recalc();
      });
      root.addEventListener('change', recalc);
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sac-slope]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      root.querySelectorAll('[data-sac-slope]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      recalc();
    });

    recalc();
  }

  function boot() {
    document.querySelectorAll('[data-shot-angle-calc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
